export default {

  setLayout(state, payload) {
    state.layout = payload
  }

}
